import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {AnalyticsTracker} from '../../utils/AnalyticsTracker';
import {ProfileType} from '../../model/profile-type.model';

@Component({
    selector: 'app-borrower-campaign',
    templateUrl: './borrower-campaign.component.html',
    styleUrls: ['./borrower-campaign.component.css', '../../../assets/styles/new-styles.css', './borrower-campaign-banner.css']
})
export class BorrowerCampaignComponent {
    public analyticsTracker: AnalyticsTracker;
    ProfileType = ProfileType;

    constructor(analyticsTracker: AnalyticsTracker, private route: Router) {
        this.analyticsTracker = analyticsTracker;
    }

    getCurrentUrl(): string {
        return this.route.url.split('#')[0];
    }
}
